// Start - migrated over from Delugs Flex theme
var csv_url = $('.strap-gallery__container').attr('csv');
var limit = parseInt($('.strap-gallery__container').attr('load'));
jQuery.ajax({
    url: csv_url,
    cache: false,
    success: function(response) {
        var csv_array = response.split(/\r?\n/);
        for (let i=0; i < csv_array.length; i++) {
            csv_array[i] = csv_array[i].split(',');
        }
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
        //Init images element
        function initGalleryContent() {
            $('.strap-gallery__image-container').empty();
            for (let i=4; i < csv_array.length; i++) {
                var image_url =  '//cdn.shopify.com/s/files/1/0054/9040/9585/files/' + csv_array[i][0];
                image_url = image_url.replace('.jpg', '_1000x.jpg')
                var image = `<img src="${image_url}" class="lazyload">`;
                var tags = "";
                var length_difference = csv_array[i].length - csv_array[0].length;
                var description = '';
                var detail_categories = [];
                var detail_categories_items = [];
                var hide = '';
                if (i > limit) {
                    hide = ' hide';
                } else {
                    hide = ' loaded'
                }
                //modal informations
                var reference = '';
                if (csv_array[i][1] != '') {
                    reference = `<div class="strap-gallery__modal-details-reference"><span>${csv_array[1][1]}:</span>${csv_array[i][1]}</div>`
                }
                for (let d=2; d < csv_array[1].length; d++) {
                    detail_categories.push(csv_array[1][d]);
                }
                detail_categories = detail_categories.filter(onlyUnique);
                for (let d=0; d < detail_categories.length; d++) {
                    detail_categories_items.push([]);
                }
                for (let c= 2; c < csv_array[i].length; c++) {
                    var tag = ''
                    tag = csv_array[i][c].replace('"', '');
                    //get all tags
                    for (let d=0; d < detail_categories.length; d++) {
                        if (csv_array[1][c] == detail_categories[d]) {
                            if (tag != '-') {
                                detail_categories_items[d].push(`${csv_array[0][c]}: ${tag}`);
                            }
                            var category= csv_array[0][c];
                            if (category.includes(' ')) {
                                category = category.replace(/ /g, '_');
                            }
                            if (category == "style" || category == "Style") {
                                category = "filter_style"
                            }
                            tags = tags + `${category}="${tag}"`
                        }
                    }
                    // if (tag != '') {
                    //     tags = tags + ` ${csv_array[0][c].replaceAll(' ', '_')}="${tag}"`;
                    // }
                }
                var modal_detail_categories = '';
                for (let d=0; d < detail_categories.length; d++) {
                    var detail_category_items = '';
                    for (let b=0; b < detail_categories_items[d].length; b++) {
                        detail_category_items = detail_category_items + `<div class="strap-gallery-modal-detail-item">${detail_categories_items[d][b]}</div>`
                    }
                    if (detail_categories[d].toLowerCase() != "no") {
                        modal_detail_categories = modal_detail_categories + `<div class="strap-gallery__modal-detail-category"><h3>${detail_categories[d]}</h3>${detail_category_items}</div>`
                    }
                }
                modal_detail_categories = `<div class="strap-gallery__modal-details-content">${modal_detail_categories}</div>`;
                var modal_details = `<div class="strap-gallery__modal-details"><h2>Strap Details</h2>${reference}${modal_detail_categories}</div>`;
                var item = `<div class="stray-gallery__image${hide}" image_src="${image_url}" index="${i - 3}" ${tags}>${image} ${modal_details}</div>`;
                $('.strap-gallery__image-container').append(item);        
            }
            if (csv_array.length > limit) {
                $('.strap-gallery__load-more').removeClass('hide');
            } else {
                $('.strap-gallery__load-more').addClass('hide');
            }
            $('.strap-gallery__load-more').attr('current', limit);
            $('.stray-gallery__image').click(function(event){
                $('html').addClass('modal-open');
                $('.strap-gallery__modal').addClass('open');
                $('.strap-gallery__overlay').addClass('open');
                var img_src = $(event.currentTarget).find('img').attr('src');
                var image = `<img src="${img_src}" class="lazyload">`;
                $('.strap-gallery__modal-image').empty();
                $('.strap-gallery__modal-image').append(image)
                var clone = $(event.currentTarget).find('.strap-gallery__modal-details').clone();
                $('.strap-gallery__modal-details-wrapper').empty();
                $('.strap-gallery__modal-details-wrapper').append(clone);
                var img_description = $(event.currentTarget).find('.stray-gallery__desctiption').text();
                $('.strap-gallery__modal-description').empty();
                $('.strap-gallery__modal-description').append(img_description);
                var index = $(event.currentTarget).attr('index');
                $('.strap-gallery__modal').attr('index', index);
                var max = $('.stray-gallery__image').length;
                if ($('.stray-gallery__image.active').length > 0) {
                    max = $('.stray-gallery__image.active').length;
                }
                $('.strap-gallery__modal').attr('index', index);
                $('.strap-gallery__modal').attr('max', max);
                if (index == 1) {
                    $('.strap-gallery__modal-prev').addClass('hide');
                } else {
                    $('.strap-gallery__modal-prev').removeClass('hide');
                }
                if (index == max) {
                    $('.strap-gallery__modal-next').addClass('hide');
                } else {
                    $('.strap-gallery__modal-next').removeClass('hide');
                }
            });
            $(document).on('keydown',function(e) {
                if ($('.strap-gallery__modal').hasClass('open')) {
                    var code = (e.keyCode ? e.keyCode : e.which);
                    if (code == 37) {
                        if (!$('.strap-gallery__modal-prev').hasClass('hide')) {
                            $('.strap-gallery__modal-prev').click();
                        }
                    } else if (code == 39) {
                        if (!$('.strap-gallery__modal-next').hasClass('hide')) {
                                $('.strap-gallery__modal-next').click();
                            }
                    }
                }
              });
            $('.strap-gallery__modal-next').click(function(){
                var target = $(this).parents('.strap-gallery__modal');
                var index = parseInt(target.attr('index'));
                var max = parseInt(target.attr('max'));
                index = index + 1;
               
                var img_src =  $(`.stray-gallery__image[index=${index}]`).find('img').attr('src');
                var image = `<img src="${img_src}" class="lazyload">`;
                $('.strap-gallery__modal-image').empty();
                $('.strap-gallery__modal-image').append(image);
                var clone = $(`.stray-gallery__image[index=${index}]`).find('.strap-gallery__modal-details').clone();
                $('.strap-gallery__modal-details-wrapper').empty();
                $('.strap-gallery__modal-details-wrapper').append(clone);
                var img_description = $(`.stray-gallery__image[index=${index}]`).find('.stray-gallery__desctiption').text();
                $('.strap-gallery__modal-description').empty();
                $('.strap-gallery__modal-description').append(img_description);

                $('.strap-gallery__modal').attr('index', index);
                
                if (index == max) {
                    $('.strap-gallery__modal-next').addClass('hide');
                } else {
                    $('.strap-gallery__modal-next').removeClass('hide');
                }
                $('.strap-gallery__modal-prev').removeClass('hide');
            });
            $('.strap-gallery__modal-prev').click(function(){
                var target = $(this).parents('.strap-gallery__modal');
                var index = parseInt(target.attr('index'));
                var max = parseInt(target.attr('max'));
                index = index - 1;
               
                var img_src =  $(`.stray-gallery__image[index=${index}]`).find('img').attr('src');
                var image = `<img src="${img_src}" class="lazyload">`;
                $('.strap-gallery__modal-image').empty();
                $('.strap-gallery__modal-image').append(image);
                var clone = $(`.stray-gallery__image[index=${index}]`).find('.strap-gallery__modal-details').clone();
                $('.strap-gallery__modal-details-wrapper').empty();
                $('.strap-gallery__modal-details-wrapper').append(clone);
                var img_description = $(`.stray-gallery__image[index=${index}]`).find('.stray-gallery__desctiption').text();
                $('.strap-gallery__modal-description').empty();
                $('.strap-gallery__modal-description').append(img_description);

                $('.strap-gallery__modal').attr('index', index);
                console.log(index)
                if (index == 1) {
                    $('.strap-gallery__modal-prev').addClass('hide');
                } else {
                    $('.strap-gallery__modal-prev').removeClass('hide');
                }
                $('.strap-gallery__modal-next').removeClass('hide');
            });
        }
        //init Filter elements
        function initFilter() {
            var filter_categories = [];
            for (let i = 2; i < csv_array[0].length; i++) {
                filter_categories.push([]);
                filter_categories[i - 2].push([]);
                filter_categories[i - 2][0].push(csv_array[0][i]);
            }
            for (let m = 4; m < csv_array.length; m++) {
                for (let c = 0; c < filter_categories.length; c++) {
                    var length_difference = csv_array[m].length - csv_array[0].length;
                    var index = c + length_difference + 2;
                    if (filter_categories[c][1] == undefined) {
                        filter_categories[c].push(csv_array[2][index])
                    }
                    if (filter_categories[c][2] == undefined) {
                        filter_categories[c].push(csv_array[3][index])
                    }
                    if (csv_array[m][index].includes(';')) {
                        var options = csv_array[m][index].split(';');
                        for (let o = 0; o < options.length; o ++) {
                            filter_categories[c][0].push(options[o].trim());
                        }
                    } else {
                        filter_categories[c][0].push(csv_array[m][index]);
                    }
                }
            }
            // get all unique filter categories
            for (i = 0; i < filter_categories.length; i++) {
                filter_categories[i][0] = filter_categories[i][0].filter(onlyUnique);
            }
            console.log(filter_categories)
            // Filter Container
            var filter_container = []
            for (let i = 2; i < csv_array[2].length; i++) {
                filter_container.push(csv_array[2][i]);
            }
            filter_container = filter_container.filter(onlyUnique);

            //FILTER ELEMENTS
            var plus_icon = '<span class="icon icon-plus"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 7.33l2.829-2.83 9.175 9.339 9.167-9.339 2.829 2.83-11.996 12.17z"/></svg></span>';
            var minus_icon = '<span class="icon icon-minus"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 16.67l2.829 2.83 9.175-9.339 9.167 9.339 2.829-2.83-11.996-12.17z"/></svg></span>'
            var remove_icon = '<svg class="icon icon-selected" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><path d="M52.83,50,96.41,6.41a2,2,0,0,0-2.82-2.82L50,47.17,6.41,3.59A2,2,0,0,0,3.59,6.41L47.17,50,3.59,93.59a2,2,0,1,0,2.82,2.82L50,52.83,93.59,96.41a2,2,0,0,0,2.82-2.82Z"></path></g></svg>'
            var checkbox = '<div class="strap-gallery__checkbox"></div>'
            for (let i = 0; i < filter_container.length; i++) {
                var checker = filter_container[i].toLowerCase();
                if (checker != "no" && checker != "") {
                    var filter_category = `<div class="strap-gallery__filter-category-container"><div class="strap-gallery__filter-button category">${plus_icon}${minus_icon}<div class="strap-gallery__filter-option-buttons category">${filter_container[i]}</div></div><div class="strap-gallery__filter-category-categories" category="${filter_container[i]}"></div></div>`
                    $('.strap-gallery__filter-wrapper').append(filter_category);
                }
            }
            console.log("INITIAL FILTER OPTION SORT")
            for (i = 0; i < filter_categories.length; i++) {
                // Sort Filter Options
                var options_array = [];
                var filter_label = filter_categories[i][0][0]
                var options_category = filter_categories[i][0][0].replace(/ /g, "_");
                // console.log("Original: " + filter_categories[i][2])
                // console.log(filter_categories[i][0])
                if (filter_categories[i][2] == "Alphabetical") {
                    for (o = 1; o < filter_categories[i][0].length; o++){
                        options_array.push(filter_categories[i][0][o]);
                    }
                    options_array = options_array.sort()
                } else {
                    for (o = 1; o < filter_categories[i][0].length; o++){
                        var count = 0;
                        var option_array = [];
                        option_array.push(filter_categories[i][0][o]);
                        $('.stray-gallery__image').each(function(){
                            if ($(this).attr(options_category) != undefined) {
                                if ($(this).attr(options_category) == filter_categories[i][0][o]) {
                                    count = count + 1;
                                }
                            }
                        });
                        option_array.push(count);
                        options_array.push(option_array);
                    }
                    options_array = options_array.sort(function(a, b){return b[1] - a[1]})
                    var array_to_string = []
                    for (o = 0; o < options_array.length; o++){
                        array_to_string.push(options_array[o][0])
                    }
                    options_array = array_to_string;
                }
                options_array.unshift(options_category)
                filter_categories[i][0] = options_array;

                //create filter category element
                var options = ''
                for (let o = 1; o < filter_categories[i][0].length; o++) {
                    if (filter_categories[i][0][o] != '') {
                        if (o == 1) {
                            if (filter_categories[i][0][o] != '-') {
                                options = options + `<div class="strap-gallery__filter-option" value="${filter_categories[i][0][o]}" selected><div class="filter">${checkbox}${filter_categories[i][0][o]}</div><span class="result-count"></span></div>`;
                            }
                        } else {
                            options = options + `<div class="strap-gallery__filter-option" value="${filter_categories[i][0][o]}"><div class="filter">${checkbox}${filter_categories[i][0][o]}</div><span class="result-count"></span></div>`
                        }
                    }
                }
                //hide category
                if (filter_categories[i][0].length == 2 && filter_categories[i][0][1] != '  ') {
                
                } else {
                    //show categor
                    if (filter_categories[i][0] != ''){
                        if ($('.strap-gallery__filter-category-container').length > 0) {
                            var first = $('.strap-gallery__filter-category-container').first();
                            if (filter_categories[i][1] != undefined) {
                                if (filter_categories[i][1].toLowerCase() == "no") {
                                } else {
                                    var item_filter = filter_categories[i][0][0].toLowerCase();
                                    if (item_filter == "style" || item_filter == "Style") {
                                        item_filter = "filter_style";
                                    }
                                    if (filter_categories[i][1] == '') {
                                        var select_element = `<div class="strap-gallery__filter-container show" ><div class="strap-gallery__filter-button" filter="${item_filter.toLowerCase()}" order="${filter_categories[i][2]}">${plus_icon}${minus_icon}<div class="strap-gallery__filter-option-buttons">${filter_label}<div class="clear">CLEAR</div></div></div><div class="strap-gallery__filter-option-container">${options}</div></div>`;
                                        $(select_element).insertBefore(first);
                                    } else {
                                        var select_element = `<div class="strap-gallery__filter-container"><div class="strap-gallery__filter-button" filter="${item_filter.toLowerCase()}" order="${filter_categories[i][2]}">${plus_icon}${minus_icon}<div class="strap-gallery__filter-option-buttons">${filter_label}<div class="clear">CLEAR</div></div></div><div class="strap-gallery__filter-option-container">${options}</div></div>`;
                                        $(`[category="${filter_categories[i][1]}"]`).append(select_element);
                                    }
                                }
                            }
                        } else {
                            $('.strap-gallery__filter-wrapper').append(select_element);
                        }
                    }
                } 
            }
            // Initial filter count
            $('.strap-gallery__filter-option').each(function() {
                var category = $(this).parents('.strap-gallery__filter-container').find('.strap-gallery__filter-button').attr('filter');
                var filter = $(this).attr('value');
                var count = 0;
                $('.stray-gallery__image').each(function(){
                    if ($(this).attr(category) != undefined) {
                        if ($(this).attr(category).includes(';')) {
                            var filter_attr = $(this).attr(category).split(';');
                            var match = false;
                            for (let f = 0; f < filter_attr.length; f++) {
                                if (filter_attr[f].trim() == filter) {
                                    match = true;
                                }
                            }
                            if (match) {
                                count = count + 1;
                            }
                        } else {
                            if ($(this).attr(category) == filter) {
                                count = count + 1;
                            }
                        }
                    }

                });
                if (count == 0) {
                    $(this).addClass('hide');
                    $(this).remove()
                } else {
                    $(this).removeClass('hide')
                }
                $(this).find('.result-count').text("(" + count + ")");
            });

            //Filter Listeners
            $('.strap-gallery__filter-bar, .strap-gallery__filter-wrapper-header svg').click(function(){
                $('.strap-gallery__filter-bar').toggleClass('active');
                if ($('.strap-gallery__filter-bar').hasClass('active')) {
                    $('.strap-gallery__filter-bar span').text('Filter by: Active')
                } else {
                    $('.strap-gallery__filter-bar span').text('Filter by')
                }
                
                $('.strap-gallery__filter-wrapper').toggleClass('active');
                $('.strap-gallery__overlay').toggleClass('open');
                $('html').toggleClass('modal-open');
            });
            $('.strap-gallery__overlay, .strap-gallery__modal-close').click(function(){
                $('.strap-gallery__filter-wrapper').removeClass('active');
                $(this).removeClass('open')
                $('.strap-gallery__modal').removeClass('open');
                $('.strap-gallery__overlay').removeClass('open');
                $('html').removeClass('modal-open');
            });

            $('.strap-gallery__filter-container').each(function(){
                $(this).find('.strap-gallery__filter-option').find('svg').css('display', 'none');
            })
            $('.strap-gallery__filter-button').click(function(event){
                console.log($(event.target))
                if (!$(event.target).hasClass('clear') && !$(event.target).hasClass('category')) {
                    console.log("Category")
                    $(this).parents('.strap-gallery__filter-container').toggleClass('show');
                } else {
                    if ($(event.target).hasClass('category')) {
                        console.log("category container")
                        $(this).parents('.strap-gallery__filter-category-container').toggleClass('show');
                    }
                }   
            });

            $(document).on('click', '.strap-gallery__filter-option', function(){
                $(this).toggleClass('active');                

                // show/hide clear
                var clear = $(this).parents('.strap-gallery__filter-option-container').siblings('.strap-gallery__filter-button');
                var has_active = $(this).parent('.strap-gallery__filter-option-container').find('.strap-gallery__filter-option.active');
                clear = clear.find('.clear')
                if (has_active.length > 0) {
                    clear.addClass('active');
                } else {
                    clear.removeClass('active');
                }
                $('.strap-gallery__filter-wrapper').trigger('option-change');
            });

            // Trigger filter
            $('.strap-gallery__filter-wrapper').on('option-change', function(){
                // filter images
                var active_filters = [];
                var active_categories = [];
                var url_path = window.location.pathname;
                var url_append = '';
                console.log("Filter Image")
                $('.strap-gallery__filter-option.active').each(function(){
                    var item = [];
                    var category = $(this).parents('.strap-gallery__filter-container').find('.strap-gallery__filter-button').attr('filter');
                    var filter_value = $(this).attr('value');
                    item.push(category);
                    item.push(filter_value);
                    active_filters.push(item);
                    active_categories.push(category)
                });
                active_categories = active_categories.filter(onlyUnique);
                var active_filter_per_category = [];
                // console.log(active_categories);
                for (let i = 0; i < active_categories.length; i ++) {
                    active_filter_per_category.push([]);
                    if (url_append.includes('?')) {
                        url_append = url_append + '&' + active_categories[i] + '=';
                    } else {
                        url_append = url_append + '?' + active_categories[i] + '=';
                    }
                    for (let f = 0; f < active_filters.length; f++) {
                        if (active_filters[f][0] == active_categories[i]) {
                            url_append = url_append + active_filters[f][1] + ',';
                            active_filter_per_category[i].push(active_filters[f][1]);
                        }
                    }
                }

                if (url_append.slice(-1) == ',') {
                    url_append = url_append.slice(0, -1);
                }
                url_append = url_append.replace(/,&/g, '&');
                window.history.replaceState('', '', url_path + url_append);

                $('.stray-gallery__image').removeClass('active');
                console.log("hide image if it exceeds the limit")
                if (active_filters.length > 0) {
                    //if have active filter
                    var active_elements = [];
                    //show matched
                    $('.stray-gallery__image').each(function(){
                        $(this).removeClass('hide');
                        $(this).removeClass('active');
                        active_elements.push($(this));
                    });
                    for (let c = 0; c < active_categories.length; c++) {
                        active_elements = active_elements.filter(function(image){
                            for (let i = 0; i < active_filter_per_category[c].length; i++) {
                                if (image.attr(active_categories[c]) != undefined) {
                                    if (image.attr(active_categories[c]).includes(';')) {
                                        var filter_attr = image.attr(active_categories[c]).split(';');
                                        var match = false;
                                        for (let f = 0; f < filter_attr.length; f++) {
                                            if (filter_attr[f].trim() == active_filter_per_category[c][i]) {
                                                match = true;
                                            }
                                        }
                                        if (match) {
                                            return true;
                                        }
                                    } else {
                                        if (image.attr(active_categories[c]) == active_filter_per_category[c][i]) {
                                            return true;
                                        }
                                    }
                                }
                            }
                        });
                    }   
                    //hide if exceeds the limit
                    for (let i = 0; i < active_elements.length; i++) {
                        $(active_elements[i]).attr('index', i + 1);
                        $(active_elements[i]).addClass('active');
                        // console.log(active_elements[i])
                        // console.log(i + " : " + limit)
                        if (i < limit) {
                            // console.log("less than the limit")
                            $(active_elements[i]).removeClass('hide');
                        } else {
                            // console.log("more than the limit")
                            $(active_elements[i]).addClass('hide');
                        }
                    }
                    // console.log(active_elements)
                    //hide not matched
                    var total = $('.stray-gallery__image').length;
                    $('.stray-gallery__image').each(function(){
                        if (!$(this).hasClass('active')) {
                            $(this).addClass('hide');
                            $(this).attr('index', total + 1);
                        }
                    });
                    //initiate load more
                    if (active_elements.length > limit) {
                        $('.strap-gallery__load-more').removeClass('hide');
                    } else {
                        $('.strap-gallery__load-more').addClass('hide');
                    }
                    $('.strap-gallery__load-more').attr('current', limit);

                    // append active filters
                    $('.strap-gallery__active-filter-container').addClass('active');
                    $('.strap-gallery__active-filter-container').find('.active-filter__contents').empty();
                    $('.active-filter__contents').append('<div class="clear-all">CLEAR ALL</div>')
                    for (let a = 0; a < active_filters.length; a++) {
                        var label = active_filters[a][0];
                        label = label.split('_').join(' ');
                        var close_svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z" fill="#5C5F62"></path></svg>'
                        var active_filter = `<div class="active-filter" category="${active_filters[a][0]}" filter="${active_filters[a][1]}"><div>${label}:<span>${active_filters[a][1]}</span></div>${close_svg}</div>`
                        $('.strap-gallery__active-filter-container').find('.active-filter__contents').append(active_filter);
                        label = label.split(' ').join('_');
                    }

                    //get active count after filter
                    console.log("GET ACTIVE COUNT");
                    console.log(active_filters)
                    $('.strap-gallery__filter-option').each(function() {
                        if ($(this).hasClass('active')) {
                            var count = active_elements.length;
                            // $(this).find('.result-count').text("(" + count + ")");  
                            if (count == 0) {
                                $(this).addClass('hide');
                            } else {
                                $(this).removeClass('hide')
                            }
                        } else {
                            var check_filters = [];
                            var category = $(this).parents('.strap-gallery__filter-container').find('.strap-gallery__filter-button').attr('filter');
                            var filter = $(this).attr('value');
                            var match = false;
                            for (let a = 0; a < active_filters.length; a++) {
                                if (active_filters[a][0] == category && active_filters[a][1] == filter) {
                                    match = true
                                } else {
                                    check_filters.push(active_filters[a]);
                                }
                            }
                            // console.log("CHECK FILTERS")
                            if (!match) {
                                var new_filter = [];
                                new_filter.push(category);
                                new_filter.push(filter);
                                check_filters.push(new_filter);
                            }
                            var count = 0;
                            var active_check_elements = [];
                            var active_check_category = [];

                            $('.stray-gallery__image').each(function(){
                                active_check_elements.push($(this));
                            });

                            for (let c = 0; c < check_filters.length; c++) {
                                active_check_category.push(check_filters[c][0]);
                            }

                            active_check_category = active_check_category.filter(onlyUnique);
                            // console.log(active_check_category)
                            
                                active_check_elements = active_check_elements.filter(function(image){
                                    var match_category = 0;
                                    for (let c = 0; c < active_check_category.length; c++) {
                                        for (let a = 0; a < check_filters.length; a++) {
                                            if (check_filters[a][0] == active_check_category[c]) {
                                                if (active_check_category[c] == category) {
                                                    if (image.attr(active_check_category[c]) == filter) {
                                                        match_category = match_category + 1;
                                                        break
                                                    }
                                                } else {
                                                    if (image.attr(active_check_category[c]) == check_filters[a][1]) {
                                                        match_category = match_category + 1;
                                                        break
                                                    }
                                                }

                                            }
                                        }
                                    }
                                    if (match_category == active_check_category.length) {
                                        return true
                                    }
                                });
                         
                            count = active_check_elements.length;
                            $(this).find('.result-count').text("(" + count + ")");    
                            if (count == 0) {
                                $(this).addClass('hide');
                            } else {
                                $(this).removeClass('hide')
                            }                
                        }
                    });
                } else {
                    $('.strap-gallery__active-filter-container').find('.active-filter__contents').empty();
                    $('.stray-gallery__image').each(function(index){
                        $(this).attr('index', index + 1);
                        if (index < limit) {
                            $(this).removeClass('hide');
                        } else {
                            $(this).addClass('hide');
                        }
                    });
                    //initiate load more
                    if ($('.stray-gallery__image').length > limit) {
                        $('.strap-gallery__load-more').removeClass('hide');
                    } else {
                        $('.strap-gallery__load-more').addClass('hide');
                    }
                    $('.strap-gallery__load-more').attr('current', limit);

                    // hide active filters
                    $('.clear').removeClass('active');
                    $('.strap-gallery__active-filter-container').removeClass('active');

                    //return initial filter count
                    console.log("RETURN INITIAL COUNT")
                    $('.strap-gallery__filter-option').each(function() {
                        var category = $(this).parents('.strap-gallery__filter-container').find('.strap-gallery__filter-button').attr('filter');
                        var filter = $(this).attr('value');
                        var count = $(`[${category}="${filter}"]`).length;
                        // console.log(category + " : " + filter + " : " + count)
                        $(this).find('.result-count').text("(" + count + ")");
                        if (count == 0) {
                            $(this).addClass('hide');
                        } else {
                            $(this).removeClass('hide')
                        }
                    });
                }
                //sort
                console.log("SORT AFTER FILTER")
                $('.strap-gallery__filter-container').each(function(){
                    var category = $(this).find('.strap-gallery__filter-button').attr('filter');
                    var sort_type = $(this).find('.strap-gallery__filter-button').attr('order');
                    var options = [];
                    var container = $(this).find('.strap-gallery__filter-option-container');
                    if (sort_type == "Number of photos") {
                        $(this).find('.strap-gallery__filter-option').each(function(){
                            if (!$(this).hasClass('hide')) {
                                var count = $(this).find('.result-count').text();
                                count = count.replace('(','').replace(')','');
                                count = parseInt(count);
                                var item = [];
                                item.push($(this));
                                item.push(count);
                                options.push(item);
                            }
                        });
                        options = options.sort(function(a, b){return b[1] - a[1]})
                        for (o = 0; o < options.length; o++){
                            if (!options[o][0].hasClass('active')) {
                                options[o][1] = 0;
                            }
 
                        }
                        // console.log(options)
                        options = options.sort(function(a, b){return b[1] - a[1]})
                        // console.log(options)
                        var sort_active = [];
                        var sorted_options = []
                        for (o = 0; o < options.length; o++){
                            if (!options[o][0].hasClass('active')) {
                                sorted_options.push(options[o][0])
                            }
                            if (options[o][0].hasClass('active')) {
                                sort_active.push(options[o]);
                            }
                        }
                        sort_active = sort_active.sort(function(a, b){return b[1] - a[1]});
                        var sorted_active = [] 
                        if (sort_active.length > 0) {
                            console.log("HASE ACTIVE FILTER")
                            for (a = 0; a < sort_active.length; a++){
                                sorted_active.push(sort_active[a][0]);
                            }
                            container.empty();

                            for (a = 0; a < sorted_active.length; a++){
                                container.append(sorted_active[a])
                            }
                            for (o = 0; o < sorted_options.length; o++){
                                container.append(sorted_options[o])
                            }
                        } else {
                            for (o = 0; o < sorted_options.length; o++){
                                container.append(sorted_options[o])
                            }
                        }
                    }
                });
            });

            $('.clear').click(function(){
                var parent = $(this).parents('.strap-gallery__filter-container');
                var filters = parent.find('.strap-gallery__filter-option');
                filters.each(function(){
                    $(this).removeClass('active');
                });
                $('.strap-gallery__filter-wrapper').trigger('option-change');
            });
            $(document).on('click', '.active-filter', function(){
                var category = $(this).attr('category');
                var filter = $(this).attr('filter');
                $(`[filter="${category}"]`).siblings('.strap-gallery__filter-option-container').find(`[value="${filter}"]`).removeClass('active');
                $(this).remove();
                $('.strap-gallery__filter-wrapper').trigger('option-change');
            })
            $(document).on('click', '.clear-all', function(){
                $('.strap-gallery__filter-option, .clear').each(function(){
                    $(this).removeClass('active');
                });
                $('.active-filter').remove();
                $('.strap-gallery__filter-wrapper').trigger('option-change');
            })
            var getParameterByName=	function(paramatername) {
                paramatername = paramatername.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                var regex = new RegExp("[\\?&]" + paramatername + "=([^&#]*)");
                    results = regex.exec(location.search);
                return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            }
            var has_active_onload = false;
            var url = window.location.href;
            console.log(url)
            for (i = 0; i < filter_categories.length; i++) {
                let filter_category = filter_categories[i][0][0].toLowerCase();
                if (filter_category == "style" || filter_category == "Style") {
                    filter_category = "filter_style";
                }
                var param = getParameterByName(filter_category);
                // get active filter through url parameter
                if (param != '') {
                    has_active_onload = true;
                    param = param.split(',');
                    for (let p = 0; p < param.length; p++) {
                        console.log($(`[filter="${filter_category}"]`))
                        $(`[filter="${filter_category}"]`).find('.clear').addClass('active');
                        $(`[filter="${filter_category}"]`).siblings('.strap-gallery__filter-option-container').find(`[value="${param[p]}"]`).addClass('active');
                    }
                }
            };
            if (has_active_onload) {
                $('.strap-gallery__filter-wrapper').trigger('option-change');
            }
        }
        initGalleryContent();
        initFilter();
        $('.strap-finder__loader').addClass('hide');
        $('.strap-gallery__load-more').click(function(){
            var current = parseInt($(this).attr('current'));
            var new_current = current + limit;
            var items = $('.stray-gallery__image');
            // load new page
            $(this).attr('current', new_current)
            for (let i=0; i < items.length; i++) {
                if (parseInt($(items[i]).attr('index')) < new_current){
                    $(items[i]).removeClass('hide');
                }
            }
            if (items.length > new_current) {
                $('.strap-gallery__load-more').removeClass('hide');
            } else {
                $('.strap-gallery__load-more').addClass('hide');
            }
        });
    },
    error: function(error) {

    }
  });
  // End - migrated over from Delugs Flex theme